import ReactGA from 'react-ga';

export const GAeventSubmit = (category, action, label) => {
	ReactGA.event({
		category: category,
		action: action,
		label: label,
		value: 1
	});
};